import { render, staticRenderFns } from "./DirectivesModalForLight.vue?vue&type=template&id=2870a1f0&"
import script from "./DirectivesModalForLight.vue?vue&type=script&lang=js&"
export * from "./DirectivesModalForLight.vue?vue&type=script&lang=js&"
import style0 from "./DirectivesModalForLight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports